import React, { Component } from 'react';
import { SatelliteTwoTone , AcUnitSharp, FastForwardRounded, FastRewind, InputTwoTone, GradeOutlined, TextRotationAngleup, CreateTwoTone } from '@material-ui/icons';

class serviceContainer extends Component {
     constructor (props) {
        super(props);
        this.state = {};
     }
    render() {
        return (
            <div className="container-services">
                <div className="service-row">
                    <div className="service-single"><SatelliteTwoTone className="service-fill"></SatelliteTwoTone> Website building </div>
                    <div className="service-single"><AcUnitSharp className="service-fill"></AcUnitSharp> Responsive design</div>
                    <div className="service-single"><GradeOutlined className="service-fill"></GradeOutlined> Fullstack Development</div>
                    <div className="service-single"><FastRewind className="service-fill"></FastRewind> Backend Development</div>
                    <div className="service-single"><InputTwoTone className="service-fill"></InputTwoTone> Api intergration</div>
                    <div className="service-single"><FastForwardRounded className="service-fill"></FastForwardRounded> Frontend Development</div>
                    <div className="service-single"><CreateTwoTone className="service-fill"></CreateTwoTone>Creative Design</div>
                    
                    <div className="service-single"><TextRotationAngleup className="service-fill"></TextRotationAngleup> Testing and Implementation</div>
                </div>
            </div>
        )
    }
};

export default serviceContainer;
